'use strict';

/**
 * buildDisplaySavePayload(display) — build the attribute set sent to
 * Display.prototype$patchAttributes() from view-display.js's saveDisplay().
 *
 * Kept as a pure function (mirrors the seed-template-defaults.js /
 * edit-app-connect.js pattern) so the payload shape can be asserted in unit
 * tests without instantiating the Angular controller.
 *
 * scheduleId must travel alongside appId/groupId/playlistId: selecting an
 * app, group, or playlist clears the other two assignment ids AND the
 * schedule id (see selectedApp/selectedGroup/selectedPlaylist), so omitting
 * scheduleId here would silently persist a stale schedule assignment
 * alongside a freshly chosen app/group/playlist.
 */
function buildDisplaySavePayload(display) {
    display = display || {};

    return {
        name: display.name,
        subName: display.subName,
        appId: display.appId,
        groupId: display.groupId,
        playlistId: display.playlistId,
        scheduleId: display.scheduleId,
        on: display.on,
        orientation: display.orientation,
        desiredResolution: display.desiredResolution,
        bounds: display.bounds,
        position: display.position,
        fullscreen: display.fullscreen,
        remote: display.remote,
        volume: display.volume,
        volumeControl: display.volumeControl,
        volumeSchedule: display.volumeSchedule,
        brightness: display.brightness,
        brightnessControl: display.brightnessControl,
        brightnessSchedule: display.brightnessSchedule,
        timeZone: display.timeZone,
        timer: display.timer,
        rocket: display.rocket,
    };
}

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = buildDisplaySavePayload;
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('buildDisplaySavePayload', buildDisplaySavePayload);
}
